import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule }   from '@angular/forms';
import { SigningCadesComponent } from './signing-cades.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
    imports: [CommonModule, FormsModule, SharedModule],
    declarations: [SigningCadesComponent],
    exports: [SigningCadesComponent]
})

export class SigningCadesModule { }
